import React from "react";
import { connect } from "react-redux";

// import ReactHtmlParser from "react-html-parser";
import { EditorState, convertToRaw, ContentState } from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

class ControlledEditor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editorState: EditorState.createEmpty(),
      returnHTML: "",
      emptyEditor: false
    };
  }

  componentDidMount() {
    // To check when the user backs to 1st step
    const { role, jobPreviousDesc } = this.props;
    const jobInitialState = jobPreviousDesc
      ? { jobDescription: jobPreviousDesc }
      : this.props.jobInitialState;
    console.log({ object: jobInitialState });
    if (role === "job" && jobInitialState?.jobDescription) {
      const content = jobInitialState.jobDescription;
      const blocksFromHtml = htmlToDraft(content);
      const { contentBlocks, entityMap } = blocksFromHtml;
      const contentState = ContentState.createFromBlockArray(
        contentBlocks,
        entityMap
      );
      const editorState = EditorState.createWithContent(contentState);
      console.log(editorState);
      this.setState({ editorState: editorState });
    }
    if (role === "company" && jobInitialState?.companyDescription) {
      const content = jobInitialState.companyDescription;
      const blocksFromHtml = htmlToDraft(content);
      const { contentBlocks, entityMap } = blocksFromHtml;
      const contentState = ContentState.createFromBlockArray(
        contentBlocks,
        entityMap
      );
      const editorState = EditorState.createWithContent(contentState);
      console.log(editorState);
      this.setState({ editorState: editorState });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // const { role, jobInitialState, companyInitialState } = this.props;

    if (prevState.emptyEditor !== this.state.emptyEditor) {
      this.setState({
        editorState: EditorState.createEmpty()
      });
    }
    // To check when company description already exists and if
    // it chnages then updates the description in the state.
    if (this.props.role === "company") {
      // If desc exists then replace it else empty the state.
      if (
        this.props.currentCompany.description !==
        prevProps.currentCompany.description
      ) {
        if (this.props.currentCompany.description) {
          const content = this.props.currentCompany.description;
          const blocksFromHtml = htmlToDraft(content);
          const { contentBlocks, entityMap } = blocksFromHtml;
          const contentState = ContentState.createFromBlockArray(
            contentBlocks,
            entityMap
          );
          const editorState = EditorState.createWithContent(contentState);
          console.log(editorState);
          this.setState({ editorState: editorState });
        } else this.setState({ editorState: EditorState.createEmpty() });
      }
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    // Checking if the parent wants to empty the Editor
    if (nextProps.emptyEditor !== prevState.emptyEditor) {
      return { emptyEditor: nextProps.emptyEditor };
    } else return null;
  }

  onContentStateChange = editorState => {
    this.setState(
      {
        editorState,
        returnHTML: draftToHtml(convertToRaw(editorState.getCurrentContent()))
      },
      () => this.sendDataToParent()
    );
  };

  sendDataToParent = () => {
    const { returnHTML } = { ...this.state };
    // console.log(this.state.editorState.getCurrentContent().hasText());
    const html = this.state.editorState.getCurrentContent().hasText()
      ? returnHTML
      : "";

    return this.props.onChangeHandler(html);
  };

  render() {
    const { editorState } = this.state;
    return (
      <div
        style={{
          minHeight: "20vw",
          background: "#fafafa",
          border: "1px solid #cccccc"
        }}
      >
        <Editor
          toolbar={
            this.props.role
              ? {
                  options: ["inline", "list", "history"]
                }
              : void 0
          }
          editorState={editorState}
          wrapperClassName="editor-wrapper"
          editorClassName="demo-editor"
          onEditorStateChange={this.onContentStateChange}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  // console.log(state);
  return {
    currentCompany: state.companyReducer.currentCompany,
    jobInitialState: state.jobFormReducer.jobDetails
  };
};

export default connect(mapStateToProps)(ControlledEditor);
